// export const canAccess = (user, department) => {
//   if (!user) return false;

//   // If menu item has no department → visible to all logged-in users
//   if (!department) return true;

//   // Match department
//   return user?.data?.departments?.includes(department);
// };


// export const canAccess = (user, menuDepartments,hh) => {
//   if (!user) return false;
//   // console.log("user in canAccess:",user, menuDepartments,hh);

//   const userDepartments = user?.data?.departments || [];

//   // If menu has no department restriction → allow all
//   if (!menuDepartments) return true;

//   // Normalize to array
//   const allowedDepartments = Array.isArray(menuDepartments)
//     ? menuDepartments
//     : [menuDepartments];
//   console.log("user in canAccess:",allowedDepartments,user, menuDepartments,hh);


//   // Check intersection
//   return allowedDepartments.some(dep =>
//     userDepartments.includes(dep)
//   );
// };


// export const canAccess = (user, menuRoles, menuDepartments) => {
//   if (!user || !user.data) return false;

//   const userRoles = Array.isArray(user.data.role)
//     ? user.data.role
//     : [user.data.role];

//   const userDepartments = user.data.departments || [];

//   /* ---------- ROLE CHECK (FIRST) ---------- */
//   if (menuRoles) {
//     const allowedRoles = Array.isArray(menuRoles)
//       ? menuRoles
//       : [menuRoles];

//     const hasRole = allowedRoles.some(role =>
//       userRoles.includes(role)
//     );

//     if (!hasRole) return false;
//   }

//   /* ---------- ALL DEPARTMENTS OVERRIDE ---------- */
//   if (userDepartments.includes("ALL")) {
//     return true;
//   }

//   /* ---------- DEPARTMENT CHECK (SECOND) ---------- */
//   if (menuDepartments) {
//     const allowedDepartments = Array.isArray(menuDepartments)
//       ? menuDepartments
//       : [menuDepartments];

//     const hasDepartment = allowedDepartments.some(dep =>
//       userDepartments.includes(dep)
//     );

//     if (!hasDepartment) return false;
//   }

//   return true;
// };
export const canAccess = (user, menuRoles, menuDepartments) => {
  if (!user ) return false;

  const userRoles = Array.isArray(user.role)
    ? user.role
    : [user.role];

  // const userDepartments = user.departments || [];

  /* ---------- ROLE CHECK (FIRST) ---------- */
  if (menuRoles) {
    const allowedRoles = Array.isArray(menuRoles)
      ? menuRoles
      : [menuRoles];

    const hasRole = allowedRoles.some(role =>
      userRoles.includes(role)
    );

    if (!hasRole) return false;
  }

  /* ---------- ALL DEPARTMENTS OVERRIDE ---------- */
  // if (userDepartments.includes("ALL")) {
  //   return true;
  // }

  /* ---------- DEPARTMENT CHECK (SECOND) ---------- */
  // if (menuDepartments) {
  //   const allowedDepartments = Array.isArray(menuDepartments)
  //     ? menuDepartments
  //     : [menuDepartments];

  //   const hasDepartment = allowedDepartments.some(dep =>
  //     userDepartments.includes(dep)
  //   );

  //   if (!hasDepartment) return false;
  // }

  return true;
};



